import { z } from 'zod';

// ─── Shared field schemas ────────────────────────────────────────────────────
// Single source of truth for validation rules used across auth forms.

export const emailSchema = z
  .string()
  .min(1, 'Email is required')
  .email('Please enter a valid email');

export const passwordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .regex(/[a-z]/, 'Include at least one lowercase letter')
  .regex(/[A-Z]/, 'Include at least one uppercase letter')
  .regex(/[0-9]/, 'Include at least one number');

export const loginPasswordSchema = z.string().min(1, 'Password is required');
